export default __webpack_public_path__ + "static/media/image.8197fcc9.png";